class ProfileFooterStore {
	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this.provider = staticContext.provider;
		this.cityServiceStat = staticContext.cityServiceStat;
	}

	get service() {
		return this.provider.profile?.service;
	}

	get city() {
		return this.provider.profile?.city;
	}

	get slug() {
		return this.provider.profile?.slug;
	}
}

export default ProfileFooterStore;
